import { PecDTO } from "./pecDTO";
import { CartaceoDTO } from "./cartaceoDTO";

export class InserisciRecapitoRequest {
  pec: PecDTO;
  cartaceo: CartaceoDTO;
}
